<script>
import MediaPreview from "./MediaPreview.vue";
import mediaApi from "@/helpers/media/media-api.js";

export default {
  name: "MediaDetailPanel",
  components: { MediaPreview },
  props: {
    item: {
      type: Object,
      default: null,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        name: "",
        alt: "",
      },
      saving: false,
    };
  },
  watch: {
    item: {
      immediate: true,
      handler(newItem) {
        if (newItem) {
          this.form.name = newItem.name || "";
          this.form.alt = newItem.alt || "";
        }
      },
    },
  },
  methods: {
    formatSize(bytes) {
      if (!bytes) return "—";
      if (bytes < 1024) return `${bytes} B`;
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    },
    async saveMetadata() {
      if (!this.item?.id || !this.editable) return;
      this.saving = true;
      try {
        const response = await mediaApi.update(this.item.id, {
          name: this.form.name,
          alt: this.form.alt,
        });
        this.$emit("updated", response.data.data);
      } catch (error) {
        console.error("Error updating media metadata:", error);
      } finally {
        this.saving = false;
      }
    },
    copyUrl() {
      if (!this.item?.url) return;
      navigator.clipboard.writeText(this.item.url);
      this.$bvToast.toast("URL copiada al portapapeles", {
        title: "Multimedia",
        variant: "success",
        solid: true,
        autoHideDelay: 2000,
      });
    },
  },
};
</script>

<template>
  <div v-if="item" class="media-preview-detail h-100">
    <div class="text-center mb-3">
      <MediaPreview :item="item" size="120px" />
    </div>
    <div class="mb-2">
      <label class="form-label small mb-1">Nombre</label>
      <input
        v-model="form.name"
        type="text"
        class="form-control form-control-sm"
        :disabled="!editable"
        @change="saveMetadata"
      />
    </div>
    <div class="mb-2">
      <label class="form-label small mb-1">Texto alternativo</label>
      <input
        v-model="form.alt"
        type="text"
        class="form-control form-control-sm"
        :disabled="!editable"
        @change="saveMetadata"
      />
    </div>
    <dl class="small mb-3">
      <dt>Tipo</dt>
      <dd>{{ item.mime_type || "—" }}</dd>
      <dt>Tamaño</dt>
      <dd>{{ formatSize(item.size) }}</dd>
      <dt>Subido</dt>
      <dd>{{ item.created_at || "—" }}</dd>
    </dl>
    <button type="button" class="btn btn-sm btn-outline-secondary w-100" @click="copyUrl">
      <i class="ri-file-copy-line"></i> Copiar URL
    </button>
    <div v-if="saving" class="text-muted small mt-2">Guardando...</div>
  </div>
  <div v-else class="media-preview-detail h-100 d-flex align-items-center justify-content-center text-muted">
    Selecciona un archivo para ver el detalle.
  </div>
</template>
